import Button, {
  ButtonLoading,
  ButtonRightArrow,
} from '@/components/ui/Button';
import {
  BackButton,
  MoveBackButton,
} from '@/features/v2/components/buttons/MoveBackButton';
import {
  MoveForwardButton,
  NextButton,
} from '@/features/v2/components/buttons/MoveForwardButton';
import cn from '@/utils/cn';

export type EcommerceSubmitButton = {
  label: string;
  onClick: () => void;
  isLoading?: boolean;
  disabled?: boolean;
};

// Ecommerce's terminal action is a payment redirect, not a stage submit, so it
// gets its own button here instead of SubmitStageButton(New) — see
// REFACTOR_PLAN.md stage 3.
export const EcommerceStepForm = ({
  children,
  backButton,
  nextButton,
  prevButton,
  submitButton,
  isLastStep,
  buttonsRef,
}: {
  children: React.ReactNode;
  backButton: boolean;
  nextButton?: NextButton;
  prevButton?: BackButton;
  submitButton?: EcommerceSubmitButton;
  isLastStep?: boolean;
  buttonsRef?: React.RefObject<HTMLDivElement>;
}) => {
  return (
    <>
      <div className="mb-5 w-full space-y-5 overflow-hidden">{children}</div>
      <div
        ref={buttonsRef}
        className="flex w-full flex-col-reverse items-center gap-x-5 gap-y-4 md:flex-row md:justify-end"
      >
        {backButton && (
          <MoveBackButton
            {...prevButton}
            className={cn(
              'hover:bg-gray-400 hover:text-blue-600 active:bg-gray-400 active:text-blue-600',
              prevButton?.className
            )}
          />
        )}
        {!isLastStep && <MoveForwardButton {...nextButton} />}
        {isLastStep && submitButton && (
          <Button
            type="button"
            onClick={submitButton.onClick}
            loading={submitButton.isLoading}
            disabled={submitButton.disabled}
            className="w-full md:w-auto"
          >
            {submitButton.label}
            <ButtonRightArrow />
            <ButtonLoading />
          </Button>
        )}
      </div>
    </>
  );
};
